// extracted by mini-css-extract-plugin
module.exports = {"card":"Login_card__40wuu"};